import { faEdit } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getPatientProfile } from "../../actions/profileAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import BreadCrumb from "../../components/Breadcrumb";
import ImageButton from "../../components/ImageButton";
import InfoItem from "../../components/InfoItem";
import history from "../../utils/history";
import PatientInfoEditPopup from "./PatientInfoEditPopup";
import Loader from "../../components/Loader";
import { BUCKET_NAME } from "../../constants/states";
const PatientInfo = () => {
  const dispatch = useDispatch();
  const patientId = useSelector((state) => state.role.activePatientId);
  const patientInfo = useSelector((state) => state.profile.patientProfile);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  useEffect(() => {
    if (location.state > 0) {
      dispatch(
        getPatientProfile(location.state, () => {
          setIsLoading(false);
        })
      );
    }
  }, [location.state, dispatch]);

  return (
    <div className="profile-page">
      <BreadCrumb pageName="patient" />
      {showModal && (
        <PatientInfoEditPopup
          patientInfo={patientInfo}
          closePopup={() => setShowModal(false)}
          patientId={location.state}
        />
      )}
      <h3 className="page-title">Patient Profile</h3>
      <button
        className="btn-orange mb-2"
        onClick={() => {
          history.goBack();
        }}
      >
        back
      </button>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="row">
          <ImageButton
            text="Edit"
            icon={faEdit}
            onClick={() => setShowModal(true)}
          />
          <div className="personal-section mt-3 col-md-6">
            <h5 className="profile-title">personal information</h5>
            <hr className="separator" />
            <div className="avatar">
              <img
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "contain",
                }}
                src={
                  patientInfo && patientInfo.Has_Profile_Picture
                    ? `https://storage.googleapis.com/${BUCKET_NAME}/user/${
                        patientInfo.user_id
                      }.png?${Math.random()}`
                    : Avatar
                }
                alt="user"
              />
            </div>
            <InfoItem
              title="First Name"
              value={patientInfo && patientInfo.first_name}
            />
            <InfoItem
              title="Last Name"
              value={patientInfo && patientInfo.last_name}
            />
            <InfoItem
              title="Nick Name"
              value={patientInfo && patientInfo.patient_nickname}
            />
            <InfoItem title="Email" value={patientInfo && patientInfo.email} />
            <InfoItem title="Phone" value={patientInfo && patientInfo.phone} />
          </div>
          <div className="personal-section mt-3 col-md-6">
            <h5 className="profile-title">Address information</h5>
            <hr className="separator" />
            <InfoItem
              title="Address Description"
              value={patientInfo && patientInfo.address_nickname}
            />

            <InfoItem
              title="Street"
              value={patientInfo && patientInfo.address_1}
            />
            <InfoItem
              title="Apt"
              value={patientInfo && patientInfo.address_2}
            />
            <InfoItem title="City" value={patientInfo && patientInfo.city} />
            <InfoItem title="State" value={patientInfo && patientInfo.state} />

            <InfoItem title="Zip" value={patientInfo && patientInfo.zip} />
          </div>
        </div>
      )}
    </div>
  );
};
export default PatientInfo;
